import createIcon from '../../createIcon';

/**
 * @component @name NoiseAware
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,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)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoiseAware = createIcon('NoiseAware', [
  [
    'path',
    {
      d: 'M16.0001 15H14.0001C14.0001 15.55 13.5501 16 13.0001 16C12.5701 16 12.1901 15.73 12.0501 15.32C11.9001 14.88 11.6501 14.24 11.1201 13.71L9.76008 12.35C9.28008 11.87 9.00008 11.19 9.00008 10.5C9.00008 9.12 10.1201 8 11.5001 8C12.7101 8 13.7201 8.86 13.9501 10H15.9701C15.7201 7.75 13.8101 6 11.5001 6C9.02008 6 7.00008 8.02 7.00008 10.5C7.00008 11.72 7.49008 12.91 8.35008 13.77L9.71008 15.13C9.88008 15.3 10.0201 15.57 10.1501 15.95C10.5601 17.17 11.7101 18 13.0001 18C14.6501 18 16.0001 16.65 16.0001 15Z',
      key: '1ennk7',
    },
  ],
  [
    'path',
    {
      d: 'M13.5001 14C14.3285 14 15.0001 13.3284 15.0001 12.5C15.0001 11.6716 14.3285 11 13.5001 11C12.6717 11 12.0001 11.6716 12.0001 12.5C12.0001 13.3284 12.6717 14 13.5001 14Z',
      key: 'j5tavw',
    },
  ],
  [
    'path',
    {
      d: 'M3.60008 6.58L5.18008 7.84C5.53008 7.27 5.95008 6.74 6.42008 6.27L4.85008 5.02C4.38008 5.49 3.97008 6.02 3.60008 6.58Z',
      key: '1qjj6o',
    },
  ],
  [
    'path',
    {
      d: 'M9.46008 4.42L8.59008 2.61C7.96008 2.84 7.35008 3.13 6.79008 3.48L7.66008 5.29C8.22008 4.93 8.82008 4.64 9.46008 4.42Z',
      key: '1hutcw',
    },
  ],
  [
    'path',
    {
      d: 'M4.49008 9.26L2.53008 8.81C2.32008 9.44 2.17008 10.09 2.09008 10.76L4.05008 11.21C4.11008 10.53 4.27008 9.88 4.49008 9.26Z',
      key: 'ehg1ze',
    },
  ],
  [
    'path',
    {
      d: 'M20.4001 6.58C20.0401 6.02 19.6201 5.49 19.1501 5.02L17.5701 6.28C18.0501 6.75 18.4601 7.27 18.8101 7.85L20.4001 6.58Z',
      key: 'zgtzf0',
    },
  ],
  [
    'path',
    {
      d: 'M4.04008 12.79L2.08008 13.24C2.16008 13.91 2.31008 14.57 2.52008 15.19L4.49008 14.74C4.27008 14.12 4.11008 13.47 4.04008 12.79Z',
      key: '1c969j',
    },
  ],
  [
    'path',
    {
      d: 'M17.2101 3.48C16.6401 3.13 16.0401 2.84 15.4101 2.61L14.5401 4.42C15.1801 4.64 15.7801 4.93 16.3401 5.29L17.2101 3.48Z',
      key: '1qzkhk',
    },
  ],
  [
    'path',
    {
      d: 'M13.0001 4.07V2.05C12.6701 2.02 12.3401 2 12.0001 2C11.6601 2 11.3301 2.02 11.0001 2.05V4.07C11.3301 4.03 11.6601 4 12.0001 4C12.3401 4 12.6701 4.03 13.0001 4.07Z',
      key: '1h0f77',
    },
  ],
  [
    'path',
    {
      d: 'M11.0001 19.93V21.95C11.3301 21.98 11.6601 22 12.0001 22C12.3401 22 12.6701 21.98 13.0001 21.95V19.93C12.6701 19.97 12.3401 20 12.0001 20C11.6601 20 11.3301 19.97 11.0001 19.93Z',
      key: 'er28og',
    },
  ],
  [
    'path',
    {
      d: 'M19.5101 14.74L21.4801 15.19C21.6901 14.56 21.8401 13.91 21.9201 13.24L19.9601 12.79C19.8901 13.47 19.7301 14.12 19.5101 14.74Z',
      key: '1ylqzj',
    },
  ],
  [
    'path',
    {
      d: 'M19.9601 11.21L21.9201 10.76C21.8401 10.09 21.6901 9.43 21.4801 8.81L19.5101 9.26C19.7301 9.88 19.8901 10.53 19.9601 11.21Z',
      key: 'cdpfln',
    },
  ],
  [
    'path',
    {
      d: 'M17.5801 17.73L19.1601 18.99C19.6301 18.51 20.0401 17.99 20.4101 17.43L18.8301 16.17C18.4701 16.73 18.0501 17.26 17.5801 17.73Z',
      key: '12l91x',
    },
  ],
  [
    'path',
    {
      d: 'M6.79008 20.52C7.36008 20.87 7.96008 21.16 8.59008 21.39L9.46008 19.58C8.82008 19.36 8.22008 19.07 7.66008 18.71L6.79008 20.52Z',
      key: '1o8d4u',
    },
  ],
  [
    'path',
    {
      d: 'M14.5401 19.58L15.4101 21.39C16.0401 21.16 16.6501 20.87 17.2101 20.52L16.3401 18.71C15.7801 19.07 15.1801 19.36 14.5401 19.58Z',
      key: 'sp7gvz',
    },
  ],
  [
    'path',
    {
      d: 'M3.60008 17.42C3.96008 17.98 4.38008 18.51 4.85008 18.98L6.43008 17.72C5.95008 17.25 5.54008 16.73 5.19008 16.15L3.60008 17.42Z',
      key: '1wqlm4',
    },
  ],
]);

export default NoiseAware;
